
import {
  computed, defineComponent, onMounted, reactive, ref,
  watch,
} from 'vue';
import { IOption } from '@/core/models/AntDesign/IOption';
import { useTelaBase } from '@/core/composables/TelaBase';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import storeSistema from '@/store/storeSistema';
import { IParametrosConsulta } from '@/core/models/Consulta/IParametrosConsulta';
import { IParametrosConsultaRapida } from '@/core/models/Consulta/IParametrosConsultaRapida';
import ServicoEngenhariaProduto from '@/servicos/Cadastros/PCP/ServicoEngenhariaProduto';

export default defineComponent({
  name: 'SelecionarEngenhariaProduto',
  props: {
    varios: {
      type: Boolean,
      default: false,
    },
    codigoSelecionado: {
      type: Number || undefined,
    },
    codigosSelecionados: {
      type: Array as () => number[],
      default: () => [],
    },
    descricaoSelecionado: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Selecione',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    empresas: {
      type: Array as () => number[],
      required: true,
    },
    engenharias: {
      type: Array as () => number[],
    },
    tipoProducao: {
      type: Number,
      required: true,
    },
    codigoProdutoDefinicao: {
      type: Number,
      default: 0,
    },
  },
  emits: ['update:codigoSelecionado', 'update:codigosSelecionados', 'update:descricaoSelecionado', 'change'],
  setup(props, { emit }) {
    const { montaOpcoesComListaConsultaRapida } = useTelaBase();
    const refEngenhariaProduto = ref<HTMLElement | null>(null);

    let debounce = 0;
    const servicoEngenhariaProduto = new ServicoEngenhariaProduto();
    servicoEngenhariaProduto.requisicaoSistema();

    const state = reactive({
      listaEngenharia: [] as IOption[],
      buscandoDados: false,
      emDigitacao: false,
    });

    const computedDescricaoSelecionado = computed({
      get: () => props.descricaoSelecionado,
      set: (val: string) => {
        emit('update:descricaoSelecionado', val);
      },
    });

    async function pesquisarEngenhariaIndividual(valorPesquisa: any) {
      state.emDigitacao = true;
      state.buscandoDados = true;
      state.listaEngenharia = [];
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        const parametrosConsultaRapida: IParametrosConsultaRapida = {
          valor: valorPesquisa,
          apenasAtivos: false,
          recursoAssociado: '',
          quantidadeRegistros: 1,
          filtrarPorCodigo: true,
        };
        if (UtilitarioGeral.validaLista(props.empresas)) {
          parametrosConsultaRapida.empresas = props.empresas;
        } else {
          parametrosConsultaRapida.empresas = storeSistema.getters.empresasUsuarioAutenticado();
        }
        const listaEngenharia = await servicoEngenhariaProduto.consultaRapida(parametrosConsultaRapida, props.tipoProducao, props.codigoProdutoDefinicao);
        state.buscandoDados = false;
        state.listaEngenharia = montaOpcoesComListaConsultaRapida(listaEngenharia);
      }, 60);
    }

    async function obterEngenhariaPorCodigo(valor: any) {
      await pesquisarEngenhariaIndividual(valor);
      if (state.emDigitacao) { return; }
      if (!UtilitarioGeral.valorValido(valor)) { return; }
      if (!(valor > 0)) { return; }

      if (props.varios) {
        if (props.codigosSelecionados.length === 0) { return; }
      } else if (props.codigoSelecionado === 0) {
        return;
      }
      let efetuarConsulta = true;

      if (UtilitarioGeral.validaLista(state.listaEngenharia)) {
        if (props.varios) {
          const listaCodigosConsulta = state.listaEngenharia.map((c) => c.value);
          const diferencas = props.codigosSelecionados.filter((c) => !listaCodigosConsulta.includes(c));
          if (!UtilitarioGeral.validaLista(diferencas)) {
            efetuarConsulta = false;
          }
        } else {
          const existeLista = state.listaEngenharia.find((c) => c.value === props.codigoSelecionado);
          if (existeLista !== undefined) {
            efetuarConsulta = false;
          }
        }

        const option = state.listaEngenharia.find((c) => c.value === valor);
        if (option?.label !== undefined && option?.label !== '') {
          computedDescricaoSelecionado.value = option?.label;
        }
      }

      if (!efetuarConsulta) return;

      state.listaEngenharia = [];

      const parametrosConsultaRapida = {} as IParametrosConsulta;

      if (UtilitarioGeral.validaLista(props.empresas)) {
        parametrosConsultaRapida.empresas = props.empresas;
      } else {
        parametrosConsultaRapida.empresas = storeSistema.getters.empresasUsuarioAutenticado();
      }

      if (UtilitarioGeral.validaLista(props.engenharias)) {
        parametrosConsultaRapida.codigosSelecionados = props.engenharias;
      }
      const listaTipoProducao = await servicoEngenhariaProduto.consultaRapida(parametrosConsultaRapida, props.tipoProducao, props.codigoProdutoDefinicao);
      const options = montaOpcoesComListaConsultaRapida(listaTipoProducao);
      state.listaEngenharia = options;

      if (listaTipoProducao && listaTipoProducao.length === 1) {
        const itemUnico = listaTipoProducao[0];
        const optionUnica = options[0];

        if (props.varios) {
          emit('update:codigosSelecionados', [itemUnico.codigo]);
          emit('change', [itemUnico.codigo]);
        } else {
          emit('update:codigoSelecionado', itemUnico.codigo);
          if (optionUnica) {
            emit('update:descricaoSelecionado', optionUnica.label);
          }
          emit('change', itemUnico.codigo);
        }
      }

      if (!UtilitarioGeral.validaLista(listaTipoProducao)) {
        if (props.varios) {
          emit('update:codigosSelecionados', undefined);
        } else {
          emit('update:codigoSelecionado', undefined);
        }
      }
    }

    function obterEngenharia():any {
      obterEngenhariaPorCodigo(props.codigoSelecionado);
      return (props.codigoSelecionado === 0 ? undefined : props.codigoSelecionado);
    }

    function obterEngenharias():number[] {
      obterEngenhariaPorCodigo(props.codigosSelecionados);
      return props.codigosSelecionados;
    }

    const computedCodigoSelecionado = computed({
      get: () => obterEngenharia(),
      set: (val: number) => {
        emit('update:codigoSelecionado', val);
        const option = state.listaEngenharia.find((c) => c.value === val);

        if (option?.label !== undefined && option?.label !== '') {
          computedDescricaoSelecionado.value = option?.label;
        }
      },
    });

    const computedCodigosSelecionados = computed({
      get: () => obterEngenharias(),
      set: (val: number[]) => {
        emit('update:codigosSelecionados', val);
      },
    });

    async function pesquisarEngenharia(valorPesquisa: any) {
      state.emDigitacao = true;

      state.buscandoDados = true;
      state.listaEngenharia = [];
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        const parametrosConsultaRapida: IParametrosConsultaRapida = {
          valor: valorPesquisa, apenasAtivos: true, recursoAssociado: '', quantidadeRegistros: 100,
        };

        if (UtilitarioGeral.validaLista(props.empresas)) {
          parametrosConsultaRapida.empresas = props.empresas;
        } else {
          parametrosConsultaRapida.empresas = storeSistema.getters.empresasUsuarioAutenticado();
        }

        const listaEngenharia = await servicoEngenhariaProduto.consultaRapida(parametrosConsultaRapida, props.tipoProducao, props.codigoProdutoDefinicao);
        state.buscandoDados = false;
        const options = montaOpcoesComListaConsultaRapida(listaEngenharia);
        state.listaEngenharia = options;

        if (listaEngenharia && listaEngenharia.length === 1) {
          const itemUnico = listaEngenharia[0];
          const optionUnica = options[0];

          if (props.varios) {
            emit('update:codigosSelecionados', [itemUnico.codigo]);
            emit('change', [itemUnico.codigo]);
          } else {
            emit('update:codigoSelecionado', itemUnico.codigo);
            if (optionUnica) {
              emit('update:descricaoSelecionado', optionUnica.label);
            }
            emit('change', itemUnico.codigo);
          }
        }
      }, 600);
    }

    function change() {
      emit('change', props.varios ? props.codigosSelecionados : props.codigoSelecionado);
    }

    function focus() {
      if (refEngenhariaProduto.value) {
        refEngenhariaProduto.value.focus();
      }
    }

    watch(() => computedCodigoSelecionado, async (novo) => {
      if (!props.varios) {
        await pesquisarEngenhariaIndividual(novo);
        await obterEngenhariaPorCodigo(novo);
      }
    });

    watch(() => props.codigosSelecionados, (novos) => {
      if (props.varios) obterEngenhariaPorCodigo(novos);
    });

    async function carregarEAutoselecionarPorDefinicao() {
      if (!props.codigoProdutoDefinicao || props.codigoProdutoDefinicao <= 0) {
        return;
      }

      if (props.codigoSelecionado && (props.codigoSelecionado > 0 || (props.codigosSelecionados && props.codigosSelecionados.length > 0))) {
        return;
      }
      state.buscandoDados = true;
      const parametrosConsultaRapida: IParametrosConsultaRapida = {
        valor: '',
        apenasAtivos: true,
        recursoAssociado: '',
        quantidadeRegistros: 100,
      };

      if (UtilitarioGeral.validaLista(props.empresas)) {
        parametrosConsultaRapida.empresas = props.empresas;
      } else {
        parametrosConsultaRapida.empresas = storeSistema.getters.empresasUsuarioAutenticado();
      }

      const listaEngenharia = await servicoEngenhariaProduto.consultaRapida(parametrosConsultaRapida, props.tipoProducao, props.codigoProdutoDefinicao);
      const options = montaOpcoesComListaConsultaRapida(listaEngenharia);
      state.listaEngenharia = options;
      state.buscandoDados = false;

      if (listaEngenharia && listaEngenharia.length === 1) {
        const itemUnico = listaEngenharia[0];
        const optionUnica = options[0];

        if (props.varios) {
          emit('update:codigosSelecionados', [itemUnico.codigo]);
          emit('change', [itemUnico.codigo]);
        } else {
          emit('update:codigoSelecionado', itemUnico.codigo);
          if (optionUnica) {
            emit('update:descricaoSelecionado', optionUnica.label);
          }
          emit('change', itemUnico.codigo);
        }
      }
    }

    onMounted(() => {
      if (props.varios) {
        obterEngenhariaPorCodigo(props.codigosSelecionados);
      } else {
        obterEngenhariaPorCodigo(props.codigoSelecionado);
      }
      carregarEAutoselecionarPorDefinicao();
    });

    watch(() => props.codigoProdutoDefinicao, () => {
      carregarEAutoselecionarPorDefinicao();
    });

    return {
      props,
      state,
      refEngenhariaProduto,
      pesquisarEngenharia,
      computedCodigoSelecionado,
      computedCodigosSelecionados,
      computedDescricaoSelecionado,
      change,
      focus,
      pesquisarEngenhariaIndividual,
    };
  },
});
